import React from "react";
import { Doughnut } from "react-chartjs-2";
import { DashDoughnutDataset, DashFormatLabel, DashFormatValue, DashTooltipParam, DashValueMode } from "views/dashboard/components/Charts";

export interface IDashDoughnutProps {
    width?: string | number;
    height?: string | number;
    valueMode: DashValueMode;
    datasets: DashDoughnutDataset[];
    labels?: string[];
    currrencySymbol?: string;
    tooltip?: DashTooltipParam;
    onDataClick?: (dataIndex: number) => void;
}

export const DashDoughnut: React.FC<IDashDoughnutProps> = (props) => {

    const { datasets, labels, valueMode, currrencySymbol, tooltip, width = "100%", height = 300, onDataClick } = props;

    return (
        <div style={{ position: "relative", height, width }}>
            <Doughnut
                data={{
                    labels: datasets.map(p => p.label),
                    datasets: [
                        {
                            data: datasets.map(p => p.data[0].values),
                            backgroundColor: datasets.map(p => p.backgroundColor as string)
                        }
                    ]
                }}
                options={
                    {
                        responsive: true,
                        maintainAspectRatio: false,
                        cutout: "70%",
                        radius: "80%",
                        plugins: {

                            legend: {
                                position: "right",
                                fullSize: true,
                                onClick: () => { }
                            },

                            tooltip: {
                                enabled: tooltip?.enabled === true,
                                callbacks: {
                                    title: function (item: any) {
                                        var tooltip = datasets[item[0].dataIndex]?.data[0]?.tooltip;
                                        return tooltip
                                            ? tooltip.title
                                            : labels && labels[item[0].dataIndex];
                                    },
                                    label: (context) => {
                                        var t = datasets[context.dataIndex]?.data[0]?.tooltip;
                                        return t?.formatedValue ?? DashFormatValue(context.parsed, tooltip!.valueFormat, currrencySymbol);
                                    }
                                }
                            },

                            datalabels: {
                                align: "end",
                                anchor: 'end',
                                font: {
                                    weight: 'bold'
                                },
                                formatter: (value, context) => {
                                    return DashFormatLabel(value[0], valueMode);
                                }
                            },
                        },
                        onClick: (evt, el) => {
                            if (el.length > 0 && onDataClick) {
                                onDataClick(datasets[el[0].index].data[0].id);
                            }
                        }
                    }
                }
            />
        </div>
    );
};